import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Owner-Operated Accountability",
    body: "You're not a load number here. Nathan Conley III runs this company hands-on, so every shipment carries the owner's name and reputation with it.",
  },
  {
    n: "02",
    title: "Communication That Doesn't Ghost",
    body: "Real updates from pickup to delivery. You always know where your freight is and when it lands — no chasing dispatch for answers.",
  },
  {
    n: "03",
    title: "The Right Equipment, Every Load",
    body: "Dry van, flatbed, expedited or specialized — we spec the trailer to the freight, not the other way around, so nothing arrives compromised.",
  },
  {
    n: "04",
    title: "Built For The Long Haul",
    body: "Established in 2022 and growing on repeat business. We'd rather earn a lane you trust for years than a single quick load.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="border-y border-white/10 bg-surface"
    >
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-0 md:grid-cols-[0.9fr_1.4fr]">
        <div className="border-b border-white/10 px-5 py-16 md:border-b-0 md:border-r md:px-10 md:py-28">
          <div className="md:sticky md:top-28">
            <span className="text-xs uppercase tracking-[0.3em] text-brand">Why Trey's Trucking</span>
            <h2 className="mt-4 font-display text-4xl font-black uppercase leading-none tracking-tighter md:text-6xl">
              A carrier
              <br />
              you can
              <br />
              <span className="text-brand">count on.</span>
            </h2>
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#a1a1a8]">
              Four commitments that shape every mile we drive for you.
            </p>
          </div>
        </div>

        <div>
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`manifesto-chapter-${c.n}`}
              className="flex flex-col gap-4 border-b border-white/10 px-5 py-12 last:border-b-0 md:flex-row md:gap-10 md:px-10 md:py-16"
            >
              <span className="font-display text-5xl font-black leading-none text-white/15 md:text-7xl">
                {c.n}
              </span>
              <div className="pt-1">
                <h3 className="font-display text-2xl font-bold uppercase tracking-tight md:text-3xl">
                  {c.title}
                </h3>
                <p className="mt-3 max-w-lg text-base leading-relaxed text-[#a1a1a8]">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
